import { useQuery } from 'react-query';
import { useIdentity } from '../hooks/useIdentity';
import { fetchWrapper } from '../utils';
import { NAVIGATION_ENDPOINTS } from '../constants/urls';

export type MultiOrgOption = {
  organizationId: string;
  organizationName: string;
  parentId?: string;
};

export type OrgHierarchyResponse = {
  options: MultiOrgOption[];
  userOrgIds: string[];
  success: boolean;
};

export const useMultiOrgHierarchy = ({ enabled: enableQuery = true } = {}) => {
  const { data: identity, isFetched: isIdentityFetched } = useIdentity({
    enabled: enableQuery,
  });

  return useQuery(
    ['getHierarchyByZTenantId', identity?.tenantId],
    async () =>
      fetchWrapper<OrgHierarchyResponse>(NAVIGATION_ENDPOINTS.ORG_PICKER_DATA),
    {
      enabled: enableQuery && isIdentityFetched,
    },
  );
};
